import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-green-800 text-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-4">
            <h1 className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
              株式会社MELM
            </h1>
            <div className="hidden md:block text-sm">
              <p>美容商材の企画・製造・販売</p>
            </div>
          </div>
          
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="#home" className="hover:text-yellow-300 transition-colors whitespace-nowrap cursor-pointer">
              ホーム
            </a>
            <a href="#about" className="hover:text-yellow-300 transition-colors whitespace-nowrap cursor-pointer">
              会社概要
            </a>
            <a href="#products" className="hover:text-yellow-300 transition-colors whitespace-nowrap cursor-pointer">
              商品案内
            </a>
            <a href="#services" className="hover:text-yellow-300 transition-colors whitespace-nowrap cursor-pointer">
              サービス
            </a>
            <a href="#contact" className="hover:text-yellow-300 transition-colors whitespace-nowrap cursor-pointer">
              お問い合わせ
            </a>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 hover:bg-green-700 rounded cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <nav className="lg:hidden pb-4 border-t border-green-700 mt-4 pt-4">
            <div className="flex flex-col space-y-3">
              <a href="#home" className="hover:text-yellow-300 transition-colors cursor-pointer">
                ホーム
              </a>
              <a href="#about" className="hover:text-yellow-300 transition-colors cursor-pointer">
                会社概要
              </a>
              <a href="#products" className="hover:text-yellow-300 transition-colors cursor-pointer">
                商品案内
              </a>
              <a href="#services" className="hover:text-yellow-300 transition-colors cursor-pointer">
                サービス
              </a>
              <a href="#contact" className="hover:text-yellow-300 transition-colors cursor-pointer">
                お問い合わせ
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
